







































































import { snakeCase } from 'lodash'
import { Component, Mixins, Prop } from 'vue-property-decorator'

import { GroupedBotProperty } from '../../../../../../../../BotProperties/components/Properties/types'
import { ButtonView, SocketNames } from '../../../../../../components'
import SampleNodeMixin from '../../../../SampleNodeMixin'
import ProxySendMessageAction from '../../logic/Proxy/actions/ProxySendMessageAction'
import ProxyTypingAction from '../../logic/Proxy/actions/ProxyTypingAction'
import ProxyUserInputAction from '../../logic/Proxy/actions/ProxyUserInputAction'
import { SendMessageNode } from '../../logic/SendMessageNode'
import SendMessageActionSample from './components/SendMessageActionSample.vue'
import TypingActionSample from './components/TypingActionSample.vue'
import UserInputActionSample from './components/UserInputActionSample/UserInputActionSample.vue'

@Component({
  components: {
    SendMessageActionSample,
    UserInputActionSample,
    TypingActionSample,
    ButtonView,
  },
  data() {
    return {
      ProxyTypingAction,
      ProxySendMessageAction,
      ProxyUserInputAction,
      SocketNames,
      snakeCase,
    }
  }
})
export default class SampleSendMessageNode extends Mixins(SampleNodeMixin) {
  @Prop() node!: SendMessageNode

  getActionContainerClasses(index: number, guid: string): { [key: string]: boolean } {
    const action = this.node.data.proxyActions[index]

    if (action instanceof ProxyTypingAction) {
      return {}
    }

    const actionsWithoutTyping = this.node.data.proxyActions.filter((a) => !(a instanceof ProxyTypingAction))

    const indexWithoutTyping = actionsWithoutTyping.findIndex((a) => a.guid === guid)

    return {
      'py-2': true,
      'bg-gray-200': indexWithoutTyping % 2 !== 0,
    }
  }

  get properties(): Array<GroupedBotProperty> {
    return this.node.nodeProps.getProperties()
  }
}
